import { useMemo } from 'react';

import { useGameConfig } from '../../../config/GameConfigProvider';
import { useSettingsSlice } from '../../../store/slices/settings/selectors';
import { useDictionaryService, useDictionaryValue } from '../../dictionary/reactBindings/hooks';
import type { UseAnyDictionaryService, UseAnyDictionaryValue } from '../../dictionary/reactBindings/types';
import type { DictionaryServiceOptions } from '../../dictionary/types';
import { HelpTranslations } from '../helpTranslations';

export const useHelpTranslationService: UseAnyDictionaryService = (...args) => {
  return useDictionaryService(HelpTranslations, ...args);
};

export const useHelpTranslationServiceConnected = (): ReturnType<UseAnyDictionaryService> => {
  const languageHandle = useSettingsSlice.getLanguageHandle();

  const {
    config: { translationConfig },
  } = useGameConfig();

  const options: DictionaryServiceOptions = useMemo(() => {
    return {
      keyMap: translationConfig?.helpDictionaryMap,
    };
  }, [translationConfig]);

  return useHelpTranslationService(languageHandle, translationConfig.helpFiles ?? [], options);
};

export const useHelpTranslation: UseAnyDictionaryValue = (...args) => {
  return useDictionaryValue(HelpTranslations, ...args);
};
